import axios from "./HttpRequestHotdeal"

function  getHotdeal(param){
    // return axios.post('/api/Hotdeal2023/getlist_product_v3', param);
    return axios.post('/api/Hotdeal2023/getlist_product_v25', param);
}

function getEXP(sku){
    return axios.post('/api/Hotdeal2023/get_exp_sku_hotdeal?sku='+sku);
}

function getUpsell(param){
    // return axios.post('/api/Donggiagiamgia2023/getlist_product_v1',param);
    return axios.post('/api/Donggiagiamgia2023/getlist_product_25',param);
}
function  getHotdealFunction(param){
    return axios.post('/api/Hotdeal2023/getlist_function', param);
}
function  getHotdealGroup(param){
    return axios.post('/api/Hotdeal2023/getlist_group', param);
}
export { getHotdeal, getEXP, getUpsell, getHotdealFunction,getHotdealGroup};